export default function Privacy() {
  return (
    <div className="page">
      <h1>Privacy Policy</h1>

      <p>We respect your privacy and protect your data.</p>

      <h3>Data We Collect</h3>
      <p>Name, email, phone, and financial records.</p>

      <h3>Usage</h3>
      <p>We use your data to manage your account and improve services.</p>

      <h3>Security</h3>
      <p>Your data is securely stored and never sold.</p>
    </div>
  );
}
